<template>
  <div>
    <div>
      <el-button size="mini" @click="setComponentId('VirtuallyMain')">返回</el-button>
    </div>
    <div class="cdj_table">
      <div class="cdj_display">
        <!-- 左 -->
        <div class="cdj_left">
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>仪表编号</div>
            <div class="cdj_el-input">
              <el-input size="mini" v-model="houesmoney.dummy_meter_id"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>仪表名称</div>
            <div class="cdj_el-input">
              <el-input size="mini" v-model="houesmoney.dummy_meter_name"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>倍率</div>
            <div class="cdj_el-input">
              <el-input size="mini" v-model="houesmoney.dynameter"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">排序编号</div>
            <div class="cdj_el-input">
              <el-input size="mini" v-model="houesmoney.sort"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">备注</div>
            <div class="cdj_el-input">
              <el-input v-model="houesmoney.remark" type="textarea" :rows="2"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>仪表状态</div>
            <div class="cdj_el-input" style="margin-top: 2px;">
              <RadioGroup v-model="houesmoney.is_using">
                <Radio label="1">在用</Radio>
                <Radio label="2">停用</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">报告类型</div>
            <div class="cdj_el-input" style="margin-top: 2px;">
              <CheckboxGroup v-model="houesmoney.report_type_id">
                <Checkbox label="1">仪表用量表</Checkbox>
                <Checkbox label="2">公共能耗表</Checkbox>
                <Checkbox label="3">能源汇总表</Checkbox>
                <Checkbox label="4">电力负荷估算表</Checkbox>
                <Checkbox label="5">电力负荷汇总表</Checkbox>
              </CheckboxGroup>
            </div>
          </div>
          <!-- <div class="cdj_left_display cdj_top">
             <div class="cdj_left_display_background"><span style="color:red">*</span>能耗类型</div>
             <div class="cdj_el-input">
               <RadioGroup v-model="houesmoney.energy_type">
                   <Radio label="1">业主分摊</Radio>
                   <Radio label="2">物业包干制</Radio>
               </RadioGroup>
             </div>
           </div>
           <div class="cdj_left_display cdj_top">
             <div class="cdj_left_display_background"><span style="color:red">*</span>能耗性质</div>
             <div class="cdj_el-input">
               <RadioGroup v-model="houesmoney.energy_nature">
                   <Radio label="1">住宅能耗</Radio>
                   <Radio label="2">商铺能耗</Radio>
                   <Radio label="3">公区能耗</Radio>
               </RadioGroup>
             </div>
           </div> -->
        </div>
        <!-- 右 -->
        <div class="cdj_left">
          <div class="cdj_left_display">
            <div class="cdj_left_display_background"><span style="color:red">*</span>所在房产</div>
            <div class="cdj_el-input">
              <el-select
                style="width:100%"
                v-model="houesmoney.HouseName"
                class="search"
                size="mini"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="可搜索房产"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in selectList"
                  :key="item.house"
                  :label="item.house"
                  :value="item.house">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">户号</div>
            <div class="cdj_el-input" style="display:flex;">
              <el-input size="mini" v-model="houesmoney.house_number"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>仪表性质</div>
            <div class="cdj_el-input">
              <RadioGroup v-model="houesmoney.meter_kind">
                <Radio label="0">计量表</Radio>
                <Radio label="1">分摊计费表</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>仪表类型</div>
            <div class="cdj_el-input">
              <el-select v-model="houesmoney.meter_type_id" style="width: 100%" clearable size="mini" placeholder="仪表类型">
                <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background"><span style="color:red">*</span>收费标准</div>
            <div class="cdj_el-input">
              <el-select v-model="houesmoney.charge_id" style="width: 100%" clearable size="mini" placeholder="收费标准">
                <el-option v-for="item in share_like" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">分摊金额</div>
            <div class="cdj_el-input" style="display:flex;">
              <el-input size="mini" :disabled="true"></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">上传附件</div>
            <div class="cdj_el-input" style="display:flex;">
<!--              <el-upload-->
<!--                class="upload-demo"-->
<!--                :action="url"-->
<!--                :on-change="handleChange"-->
<!--                :file-list="fileList">-->
<!--                <el-button size="mini" type="primary">上传</el-button>-->
<!--              </el-upload>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cdj_div">用量计算公式</div>
    <div class="cdj_table">
      <div class="cdj_display">
        <el-input v-model="houesmoney.expressions" type="textarea" :rows="3"></el-input>
      </div>
    </div>
    <div class="cdj_div">金额计算公式（为空就表示和用量计算公式一致，一般情况可以不设置）</div>
    <div class="cdj_table">
      <div class="cdj_display">
        <el-input v-model="houesmoney.sum_expressions" type="textarea" :rows="3"></el-input>
      </div>
    </div>
    <div class="cdj_div">读数计算公式</div>
    <div class="cdj_table">
      <div class="cdj_display">
        <el-input v-model="houesmoney.degrees_expressions" type="textarea" :rows="3"></el-input>
      </div>
    </div>
    备注<br/>
    本操作用于设置虚拟表及虚拟表的收费对象；<br/>
    金额计算公式一般用在其金额不是根据用量乘以单价的情况下，而是根据不同虚拟表的计算结果得来的情况； <br/>
  </div>
</template>

<script>
export default {
  name: "VirtuallyData",
  inject:["mainObj","setComponentId"],
  data(){
    return{
      houesmoney:{
        id:'',
        dummy_meter_id:'',
        dummy_meter_name:'',
        dynameter:'1',
        sort:0,
        remark:'',
        is_using:'1',
        report_type_id:[],
        HouseName:'',
        house_number:'',
        meter_kind:'1',
        meter_type_id:'',
        charge_id:'',
        expressions:'',
        sum_expressions:'',
        degrees_expressions:'',
        file_id:[],
        energy_type:'',
        energy_nature:'',
      },
      meter_type_list:[],
      selectList:[],
      share_like:[],
      loading:false,
    }
  },
  activated() {
    const that=this;
    that.getMeterTypeList();
    that.shareCharge();
    that.getData(that.mainObj.id);
  },
  mounted() {
    const that=this;
    that.getMeterTypeList();
    that.shareCharge();
    that.getData(that.mainObj.id);
  },
  methods:{
    getMeterTypeList(){
      const that=this;
      //仪表类型
      ERP.getRequest({
        url:"admin/common/meter_type_list",
        data:{}
      },ret=>{
        that.meter_type_list=ret.data;
      })
    },
    //收费标准
    shareCharge(){
      const that=this;
      ERP.getRequest({
        url:"admin/common/share_charge",
        data:{pid:that.mainObj.project_id}
      },ret=>{
        that.share_like=ret.data;
      })
    },
    //搜索房产
    remoteMethod(query) {
      const that=this;
      if (query !== "") {
        that.loading = true;
        ERP.getRequest({
          url:"admin/common/house_text2",
          data:{
            text:query,
            project_id:that.mainObj.project_id
          }
        },ret=>{
          that.selectList=ret.data;
          that.loading=false;
        })
      } else {
        this.selectList = [];
      }
    },
    //编辑查询
    getData(id){
      const that=this;
      if(id){
        ERP.getRequest({
          url:"admin/ShareMeter/getUpdate",
          data:{
            id:id,
          }
        },ret=>{
          that.houesmoney=ret.data;
        })
      }else {
        that.houesmoney={
          id:'',
          dummy_meter_id:'',
          dummy_meter_name:'',
          dynameter:'1',
          sort:0,
          remark:'',
          is_using:'1',
          report_type_id:[],
          HouseName:'',
          house_number:'',
          meter_kind:'1',
          meter_type_id:'',
          charge_id:'',
          expressions:'',
          sum_expressions:'',
          degrees_expressions:'',
          file_id:[],
          energy_type:'',
          energy_nature:'',
        };
      }


    },

    submit(){
      const that=this;
      ERP.showLoading()
      ERP.postRequest({
        url:"admin/ShareMeter/add",
        data:that.houesmoney,
      },ret=>{
        ERP.hideLoading()
        if(ret.code == 200){
          that.$Message.success(ret.message);
        }else{
          that.$Message.error(ret.message);
        }
      })
    },
    chargeItemNames1(){
      const that=this;
      ERP.getRequest({
        url:"admin/RoomSetUp/chargeItem_name",
        data:{
          chargeItem_name_id:that.houesmoney.xsc_ChargeItemID_id,
          pid:that.mainObj.project_id,
        }
      },ret=>{
        that.houesmoney.chargeitemID = '';
        that.charges1 = ret.data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.cdj_div{
  padding: 7px;
  background-color: #ececec;
}
.cdj_table{
  width: 100%;
  border-left: 1px solid #ececec;
  border-right: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 5px;
}
.cdj_display{
  display: flex;
}
.cdj_left{
  width: 50%;
  color: #000;
}
.cdj_left_display{
  display: flex;
}
.cdj_left_display_background{
  width: 130px;
  padding: 5px;
  background-color: #ececec;
}
.cdj_el-input{
  width: 60%;
  margin-left: 5px;
}
.el-date-pickers{
  display: flex;
}
.cdj_text_data{
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 4px;
}
.cdj_top{
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyData.vue